import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SclAceEditorService {

  constructor() {
  }


/////////

  enableFullscreen(aceEditor, fieldName) {
    const aced = document.getElementById(fieldName) as HTMLInputElement;
    const matIcon = document.createElement('mat-icon');

    const btn = document.createElement('button');
    matIcon.className = 'editor-resize-fullscreen-icon mat-icon notranslate material-icons mat-icon-no-color';
    matIcon.innerText = 'fullscreen';
    matIcon.title = 'Enter fullscreen';
    matIcon.id = 'editorFullScreenIcon';
    // btn.append(matIcon);
    btn.appendChild(matIcon);
    if (this.hasClass(aced, 'fullScreen')) {
      matIcon.innerText = 'fullscreen_exit';
      matIcon.title = 'Exit fullscreen';
    }
    this.editorStyle(aced);

    btn.className = 'gbl-fse-btn';
    btn.style.position = 'absolute';
    btn.style.top = '0px';
    btn.style.right = '0px';
    btn.style.opacity = '0.3';
    btn.style.zIndex = '1';
    btn.style.cursor = 'pointer';
    btn.style.color = 'initial';

    btn.addEventListener('click', function(e) {
        const scrollBar = aced.getElementsByClassName('ace_scrollbar-v')[0] as HTMLElement;
        const editorFullScreenIcon = document.getElementById('editorFullScreenIcon') as HTMLInputElement;
        if (this.hasClass(aced, 'fullScreen')) {
          this.removeClass(aced, 'fullScreen');
          editorFullScreenIcon.innerText = 'fullscreen';
          editorFullScreenIcon.title = 'Enter fullscreen';
          if (scrollBar) {
            scrollBar.style.display = 'none';
          }
          aceEditor.setAutoScrollEditorIntoView(true);
          aceEditor.setOptions({
              maxLines: Infinity
          });
          btn.style.top = '0px';
          btn.style.right = '0px';
        } else {
          this.addClass(aced, 'fullScreen');
          editorFullScreenIcon.innerText = 'fullscreen_exit';
          editorFullScreenIcon.title = 'Exit fullscreen';
          if (scrollBar) {
            scrollBar.style.display = null;
          }

          const lineGroup = aced.getElementsByClassName('ace_line_group')[0] as HTMLElement;
          let lineHeight;
          if (lineGroup) {
            lineHeight = lineGroup.style.height;
          }
          const editorHeight = aced.offsetHeight; // parseInt(aced.offsetHeight);
          const maxLine = isNaN(Math.ceil(editorHeight / lineHeight)) ? 0 : Math.ceil(editorHeight / lineHeight);
          aced.style.height = editorHeight + 'px';

          aceEditor.setOptions({
              maxLines: 0
          });
          aceEditor.setAutoScrollEditorIntoView(false);

          btn.style.top = '1px';
          btn.style.right = '20px';
        }


        aceEditor.resize();
        aceEditor.focus();

    }.bind(this));

    aced.appendChild(btn);

  }

  editorStyle(aced) {
    const styleNode = document.createElement('style') as HTMLStyleElement;
    styleNode.type = 'text/css';

    let css = '.ace_editor.fullScreen { ' +
      'overflow-y:auto;height: auto!important;width: auto;' +
      'border: 0;margin: 0;position: fixed !important;' +
      'top: 90px;bottom: 0;left: 0;right: 0;z-index: 9999;' +
      '}';
    css += '.ace_editor .gbl-fse-btn:hover{ opacity: 0.9!important; }';
    css += '.fullScreen{ overflow: hidden }';

    // browser detection (based on prototype.js)
    if (!!((window as any).attachEvent && !(window as any).opera)) {
        // styleNode.styleSheet.cssText = css;//TO DO
    } else {
        const styleText = document.createTextNode(css);
        styleNode.appendChild(styleText);
    }
    aced.parentNode.appendChild(styleNode);
  }

  hasClass(el, clsname) {
    const classNames = el.className.split(' ');
    for (let i = 0; i < classNames.length; i++) {
        if (clsname === classNames[i]) {
            return true;
        }
    }
    return false;
  }

  addClass(el, clsname) {
    if (!this.hasClass(el, clsname)) {
        el.className = (el.className + ' ' + clsname);
    }
  }

  removeClass(el, clsname) {
    const classNames = el.className.split(' ');
    const newClasses = [];
    for (let i = 0; i < classNames.length; i++) {
        if (clsname !== classNames[i]) {
            newClasses.push(classNames[i]);
        }
    }

    el.className = newClasses.join(' ');
  }



/////////



}
